<template>
  <div>
    <div class= "password-update field-of-fields">
        <!-- <div v-if="PassUpdate == false">
            <button class= "mylisting-button dark-button" @click.self="PassUpdate = true">Change Password</button><br>
        </div> -->

        <!-- <div v-else style="width: 80%; max-width: 450px;"> -->
          <label style="margin-top: 0;">New Password</label><br>
          <input :type="passwordFieldType" class="form-control" v-model="updateInput">
          <label>Retype Password</label><br>
          <input :type="passwordFieldType" class="form-control" v-model="updateInput2">
          <div class="mt-3">
            <button class="mylisting-button dark-button" @click.self="verifiedUpdate()">Update</button>
            <p style="color:red" class="mt-1" v-if="!matchingInput">*Passwords do not match. </p>
          </div>
        <!-- </div> -->

        <!--this was taken from Panel.vue, not sure if displaying new password in big letters is the way to go -->
        <modal name="password-reset-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
          <div class="p-5">
            <h2>Password has been reset successfully</h2>
            <hr>
            <button class="mylisting-button secondary-button" @click="$modal.hide('password-reset-modal')" style="">Close</button>
          </div>
        </modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

 export default {
     props: ['userID'],
     data(){
         return{

             PassUpdate: false,
             updateInput: '',
             updateInput2: '',
             matchingInput: true,
             passwordFieldType: 'password',
             user: '',

         }
     },

     created() {
         this.user = this.userID;
     },

     methods: {

        updatePassword() {
            axios.post('/optimum/manual-reset-password/', {
                user_id: this.user,
                password: this.updateInput2,
            })
                .then(res => {
                    console.log(res)
                    this.$modal.show('password-reset-modal')

                    this.$emit('passwordchanged')
                })
                .catch(error => {
                    console.log(error)
                })
        },

        //only checks if the passwords match, funtionality can be expanded for various password restrictions
        checkMatching() {
            if (this.updateInput == this.updateInput2){
                this.matchingInput = true;
            }
            else{
                this.matchingInput = false;
            }
        },


        verifiedUpdate() {
            this.checkMatching();
            if (this.matchingInput){
                this.updatePassword();
                //this line will collapse the input boxes and return the initial update button
                this.PassUpdate = false;
            }
        }

    }
 }
 </script>



// WEBPACK FOOTER //
// src/components/general/ChangePassword.vue